import "./Lobby.scss";
import { useContext, useMemo, useState } from "react";
import { RootState } from "../../App/store";
import Spinner from "../../components/shared/Spinner/Spinner";
import ToastService from "../../Services/ToastService";
import { useDispatch, useSelector } from "react-redux";
import {
  changeJoinedLobby,
  changeStatus,
  userInteracted,
} from "../../App/Slices/gameSlice";
import DataService from "../../Services/DataService";
import { Deposit } from "../../components/Deposit/Deposit";
import { openPopup } from "../../App/Slices/popupSlice";
import { Controls } from "../../components/Controls/Controls";
import { CounterContext } from "../../contexts/counter";

export const GameLobby = () => {
  const gameSelector = useSelector((state: RootState) => state.game);
  const userSelector = useSelector((state: RootState) => state.user);

  const dispatch = useDispatch();

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const joinBattle = async () => {
    const loadingToast = ToastService.loading(
      "Request for lobby " + gameSelector.lobby?.lobby_id
    );

    setButtonLoading(true);

    let resultJoinedLobby: any = await DataService.cloud_function
      .joinLobby()
      .catch((e) => {
        ToastService.error(e.response.data.message, { id: loadingToast });
        setButtonLoading(false);
        dispatch(changeStatus("stateless"));
      });

    if (!resultJoinedLobby) return;
    setButtonLoading(false);

    ToastService.success(
      "Succesfuly joined the lobby " + gameSelector.lobby?.lobby_id,
      {
        id: loadingToast,
      }
    );
    dispatch(changeStatus("pending"));
    dispatch(changeJoinedLobby(resultJoinedLobby.data.lobbyId));
    if (!gameSelector.userInteract) dispatch(userInteracted(true));
  };

  const leaveBattle = () => {
    setButtonLoading(true);
    const loadingToast = ToastService.loading(
      "Request for leaving lobby " + gameSelector.joinedLobbyId
    );
    DataService.cloud_function
      .leaveFromLobby({ lobbyId: gameSelector.joinedLobbyId })
      .then((result: any) => {
        dispatch(changeJoinedLobby(0));
        dispatch(changeStatus("stateless"));
        ToastService.success(result.data.message, { id: loadingToast });
      })
      .catch((e) => {
        ToastService.error(e.response.data.message, { id: loadingToast });
        window.location.reload();
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  const counterContext = useContext(CounterContext);

  const renderLobbyCounter = useMemo(() => {
    
    return (
      <Spinner
        renderContent={
          counterContext?.counter
            ? `#${gameSelector.joinedLobbyId} battle will start ${
              counterContext?.counter! <= 0 ? "now..." : `in ${counterContext?.counter} second`
              } `
            : `You are waiting for Battle #${gameSelector.joinedLobbyId}`
        }
        size={1.5}
        color="red"
        position="left"
      ></Spinner>
    );
  }, [gameSelector.joinedLobbyId, gameSelector.lobby, counterContext?.counter]);

  const renderJoinButton = useMemo(() => {
    const hasCredit =
      (userSelector.user.balance || 0) >= (gameSelector.lobby?.price || 0);
    if (!userSelector.user._id || !gameSelector.lobby?._id) return <></>;
    return hasCredit ? (
      <button disabled={buttonLoading} onClick={joinBattle}>
        {buttonLoading ? (
          <Spinner size={2} color="black" renderContent="Join Battle"></Spinner>
        ) : (
          "Join Battle "
        )}
      </button>
    ) : (
      <Deposit minPrice={gameSelector.lobby.price as number}>
        {gameSelector.lobby.price} {userSelector.user.coin} to join
      </Deposit>
    );
  }, [
    buttonLoading,
    gameSelector.status,
    userSelector.user,
    gameSelector.lobby,
  ]);

  const handleOpenControls = () => {
    dispatch(openPopup(<Controls></Controls>));
  };

  return (
    <div className="Lobby">
      <div className="control-button" onClick={handleOpenControls}>
        <span className="material-symbols-outlined">keyboard_command_key</span>
        <span>Gameplay Controls</span>
      </div>

      <div className="LobbyId">
        Battle #{gameSelector.lobby?.lobby_id} Waiting Room
      </div>
      <div className="PlayerList">
        {Array(gameSelector.lobby?.player_count)
          .fill(0)
          .map((_, i) => (
            <div className="PlayerList__player" key={i}>
              <img
                src={
                  (gameSelector.lobby?.players &&
                    gameSelector.lobby.players[i]?.image) ||
                  "/assets/game/BattleSnailPlaceholder.png"
                }
                alt=""
              />
              <div className="PlayerList__player--nickname">
                {gameSelector.lobby?.players &&
                  gameSelector.lobby.players[i]?.nick_name}
              </div>
            </div>
          ))}
      </div>
      <div className="Info">
        Each battle requires <b>minimum 2 players</b> to start.
        <h5>
          Lobby price is <b>{gameSelector.lobby?.price} {userSelector.user.coin}</b>
        </h5>
      </div>
      {userSelector.user._id && (
        <div className="JoinBattle">
          {gameSelector.status == "stateless" ? (
            renderJoinButton
          ) : (
            <div className="LeaveBattle">
              <button disabled={buttonLoading} onClick={leaveBattle}>
                {buttonLoading ? (
                  <Spinner
                    size={2}
                    color="black"
                    renderContent={`Leave From Battle`}
                  ></Spinner>
                ) : (
                  `Leave From Battle`
                )}
              </button>
              <span>
                <div>{renderLobbyCounter}</div>
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default GameLobby;
